import {Component, ViewEncapsulation} from '@angular/core';
import {ResponsiveService} from '../../../services/responsive.service';

@Component({
  selector: 'si-documentation-org-chart',
  templateUrl: './documentation-org-chart.component.html',
  styleUrls: ['./documentation-org-chart.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentationOrgChartComponent {
  isDesktop: boolean;
  orgChartModel = [
    {
      label: 'CEO',
      type: 'person',
      styleClass: 'p-person',
      expanded: true,
      name: 'Walter White',
      children: [
        {
          label: 'COO',
          type: 'person',
          styleClass: 'p-person',
          expanded: true,
          name: 'Mike E.',
          children: [
            {
              label: 'Operations',
              styleClass: 'department-coo'
            }
          ]
        },
        {
          label: 'CTO',
          type: 'person',
          styleClass: 'p-person',
          expanded: true,
          name: 'Jesse Pinkman',
          children: [
            {
              label: 'Development',
              expanded: true,
              children: [
                {
                  label: 'Analysis',
                  styleClass: 'department-cto'
                },
                {
                  label: 'Front End',
                  styleClass: 'department-cto'
                },
                {
                  label: 'Back End',
                  styleClass: 'department-cto'
                }
              ]
            }
          ]
        }
      ]
    }
  ];

  constructor(
    private responsiveService: ResponsiveService
  ) {
    this.setLogic();
  }

  setLogic(): void {
    this.isDesktop = this.responsiveService.isDesktop();
  }

}
